import { Children, type ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import { cn } from '@/lib/utils';
import { productCarouselStyles } from './ProductCarousel.styles';

export type ProductCarouselProps = {
  children: ReactNode;
  title?: ReactNode;
  spaceBetween?: number;
  className?: string;
};

export function ProductCarousel({
  children,
  title,
  spaceBetween = 16,
  className,
}: ProductCarouselProps): JSX.Element {
  const slides = Children.toArray(children);

  return (
    <section className={cn(productCarouselStyles.root, className)}>
      {title ? <h2 className={productCarouselStyles.title}>{title}</h2> : null}
      <Swiper
        modules={[FreeMode]}
        slidesPerView="auto"
        spaceBetween={spaceBetween}
        freeMode
        grabCursor
      >
        {slides.map((child, index) => (
          <SwiperSlide key={index} className={productCarouselStyles.slide}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
